import { NextPage } from 'next';
import GuestInterviewsPage from '@sy/app-client/src/ssrAdapter/pages/GuestInterviewsPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const GuestInterviews: NextPage<InferProps<typeof getServerSideProps>> = ({
	featureFlags,
	navigation,
	user,
}) => (
	<MarketingTemplate
		activePage="/guest-interviews"
		featureFlags={featureFlags}
		navigation={navigation}
		user={user}
	>
		<GuestInterviewsPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.guestInterviews'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: [
		'common',
		'auth',
		'landing',
		'landingGuestInterviews',
	],
});

export default GuestInterviews;
